import React from 'react';
import SiteHeader from '../Views/SiteHeader';
import ContactFooter from './ContactFooter';
import './ProjectLayout.css';

const ProjectLayout = ({ title, description = [], credits = [], children }) => {
  return (
    <div className="project">
      <SiteHeader />

      <main className="project__main">
        <div className="project__layout">
          <aside className="project__sidebar">
            <h1 className="project__title">{title}</h1>

            <div className="project__description">
              {description.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>

            {credits.length > 0 && (
              <div className="project__credits">
                <div className="project__credits-head">Credits</div>
                <div className="project__credits-body">
                  {credits.map((credit, index) => (
                    <span key={index}>{credit}</span>
                  ))}
                </div>
              </div>
            )}
          </aside>

          <div className="project__content">
            {children && <div className="project__media">{children}</div>}
          </div>
        </div>
      </main>

      <ContactFooter />
    </div>
  );
};

export default ProjectLayout;
